/**
 * SectionDivider · a single 1px gradient line that scroll-draws into view.
 * Used between landing sections to add rhythm without heavy chrome.
 *
 * Honors prefers-reduced-motion via useScrollAnime's snapToFinal logic.
 */

import { useScrollAnime } from "@/lib/anime/useScrollAnime";
import { DURATION, EASE } from "@/lib/anime/motion-vocab";

export function SectionDivider({ className = "" }: { className?: string }) {
  const ref = useScrollAnime<HTMLDivElement>({
    scaleX: [0, 1],
    opacity: [0, 1],
    duration: DURATION.scene, // 1200ms
    ease: EASE.glide, // inOutQuart
    threshold: 0.6,
  });
  return (
    <div aria-hidden="true" className={`relative h-px w-full overflow-hidden ${className}`}>
      <div
        ref={ref}
        className="h-full w-full origin-left bg-gradient-to-r from-transparent via-primary/30 to-transparent"
        style={{ opacity: 0, transform: "scaleX(0)" }}
      />
    </div>
  );
}
